// @flow
type KeyValuePair = { key: string, value: string };

type JsonData = {
  status: string,
  time: string,
  checks: Array<KeyValuePair>
};

export default function transformHealthCheckData(
  data: JsonData
): Array<string> {
  return data.checks
    .filter((check: KeyValuePair) => check.value === 'Unhealthy')
    .map(
      (failedCheck: KeyValuePair) =>
        `The ${failedCheck.key} is not responding`
    );
}
